import axios from "axios"
import { TYPE_FETCHING, CODE_FETCHING } from "./constants"
import { clearStorage, LOCAL_TOKEN } from "./storage"

async function returnFunctionAsync(callback = null) {
  if (callback !== null) {
    try {
      return returnFunction(await callback())
    } catch (error) {
      return error
    }
  }

  return null
}

function returnFunction(callback, all = false) {
  if (all) {
    return callback
      .then((response) => {
        if (response.status === CODE_FETCHING.error.Unauthorized) {
          clearStorage()
          return false
        }
        return response
      })
      .catch((error) => {
        throw error
      })
  }

  return callback
    .then((response) => {
      if (response.status === CODE_FETCHING.error.Unauthorized) {
        clearStorage()
        return false
      }
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

const api = (
  url = "",
  method = TYPE_FETCHING.get,
  params = {},
  asynchronous = false,
  file = false,
  host = ""
) => {
  const options = {
    method,
    url: host === "" ? process.env.API_URL + url : host,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${LOCAL_TOKEN()}`,
      "cache-control": "no-cache",
    },
  }

  switch (method) {
    case TYPE_FETCHING.post:
      options.data = params

      if (file) {
        options.headers["content-type"] = "multipart/form-data"
        options.data = params.file
      }
      break
    default:
      options.params = params
  }

  if (asynchronous) {
    return returnFunctionAsync(axios.request(options))
  }

  return returnFunction(axios.request(options))
}

export default api
